module.exports = __webpack_public_path__ + "img/Malaysia.57e6076c.png";